import { NoWarningComponent } from './no-warning.component';

import { LanguageService } from '../shared/services/language.service';
import { WarningService, WarnRegion } from './warning.service';

import { DatexPipe } from '../shared/datex.pipe';

import { CommonModule } from '@angular/common';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatOptionSelectionChange } from '@angular/material/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { ActivatedRoute, Router } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';

import { Subscription } from 'rxjs';

export const MODULES = [
  CommonModule,
  MatFormFieldModule,
  MatSelectModule,
  ReactiveFormsModule,
  MatCardModule,
  MatListModule,
  MatDividerModule,
  TranslateModule,
];
export const COMPONENTS = [FaIconComponent, NoWarningComponent];
export const PIPES = [DatexPipe];

@Component({
  selector: 'app-warning-timeline',
  templateUrl: './warning-timeline.component.html',
  styleUrls: ['./warning.component.scss'],
  imports: [...MODULES, ...COMPONENTS, ...PIPES],
})
export class WarningTimelineComponent implements OnInit, OnDestroy {
  public warningService = inject(WarningService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  public languageService = inject(LanguageService);

  sub: Subscription;
  regionControl = new UntypedFormControl();

  ngOnInit(): void {
    this.sub = this.route.params.subscribe(params => {
      if (params && params.hasOwnProperty('region')) {
        const region = params['region'];
        const [season, regionId] = region.split('_');
        this.setRegion(season, regionId);
      } else if (this.warningService.selectedRegion()) {
        this.router.navigate([
          '/warning',
          'timeline',
          this.warningService.selectedRegion().season +
            '_' +
            this.warningService.selectedRegion().id,
        ]);
      }
    });
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  setRegion(season: string, regionId: string): void {
    const warnRegion = this.warningService
      .warnRegions()
      [season].filter((r: WarnRegion) => r.id === regionId)[0];
    if (!warnRegion) {
      return;
    }
    this.warningService.selectedRegion.set({ ...warnRegion });
    this.regionControl.setValue(warnRegion.season + warnRegion.id);
  }

  onRegionChange(season: string, event: MatOptionSelectionChange): void {
    if (event.isUserInput) {
      const regionId = event.source.value.replace(season, '');
      this.router.navigate(['/warning', 'timeline', season + '_' + regionId]);
    }
  }
}
